import { render, staticRenderFns } from "./issuance_status.vue?vue&type=template&id=afd1311a&scoped=true"
import script from "./issuance_status.vue?vue&type=script&lang=js"
export * from "./issuance_status.vue?vue&type=script&lang=js"
import style0 from "./issuance_status.vue?vue&type=style&index=0&id=afd1311a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd1311a",
  null
  
)

export default component.exports